import { Trans, useTranslation } from "react-i18next";

import type { ViewAsRole } from "@/lib/view-as";

/** The texts that name someone in bold: `<strong>{{who}}</strong>` inside a sentence. */
export type StrongTextKey =
  | "roadmap.details.deleteBody"
  | "teams.block.body"
  | "teams.block.unblockBody"
  | "teams.deleteBody"
  | "users.deleteBody"
  | "users.revokeBody"
  | "viewAs.bar.person"
  | "viewAs.bar.personShort"
  | `viewAs.bar.role.${ViewAsRole}`
  | `viewAs.bar.roleShort.${ViewAsRole}`;

interface StrongTextProps {
  i18nKey: StrongTextKey;
  /** The text's placeholders, such as `{ email }`. */
  values: Record<string, string>;
  /** Classes for the bold part, such as `truncate` for a name that may be cut short. */
  strongClassName?: string;
}

/**
 * A sentence with its `<strong>` part in bold, in the dashboard's language,
 * such as "Wil je <strong>{{email}}</strong> echt verwijderen?". The values
 * are escaped before the sentence's markup is read and unescaped again as
 * plain text, so an email or a name can never turn into markup.
 */
export function StrongText({ i18nKey, values, strongClassName }: StrongTextProps) {
  const { t } = useTranslation();
  return (
    <Trans
      t={t}
      i18nKey={i18nKey}
      values={values}
      components={{ strong: <strong className={strongClassName} /> }}
      tOptions={{ interpolation: { escapeValue: true } }}
      shouldUnescape
    />
  );
}
